import type {ReactElement} from 'react';
import React from 'react';
import {IconSize} from '@Components/icon-v2/icon.types';
import {isUserPremium} from '@Libraries/user.library';
import {useAppSelector} from '@/hooks';
import {updateIsSpellCheckEnabledForUser} from '@Libraries/spell-check-library';
import {getIsSpellCheckEnabled} from '@/reducers/user-preferences.reducer';
import {IconWithTooltip} from '@Components/icon-with-tooltip/icon-with-tooltip';
import {Text, TextSize} from '@Components/text';
import type {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {ToggleSwitch} from '@Components/toggle-switch-v2';

export interface SpellCheckOptionProps {
  toggleSize?: ToggleSwitchV2Size;
}

export function SpellCheckOption(props: SpellCheckOptionProps): ReactElement<any> {
  const isSpellCheckEnabled = useAppSelector(getIsSpellCheckEnabled);
  const isSpellCheckPreferenceUpdating = useAppSelector((state) => {
    return state.userPreferences.isSpellCheckPreferenceUpdating;
  });

  const onClickHandler = (): void => {
    if (isUserPremium()) {
      void updateIsSpellCheckEnabledForUser(!isSpellCheckEnabled);
    } else {
      void window.PMW.showPremiumOnlyFeatureDialog(window.PMW.PREMIUM_ONLY_FEATURE_NAME_SPELL_CHECK);
    }
  };

  const getTag = (): ReactElement | null => {
    if (isUserPremium()) {
      return null;
    }
    return <IconWithTooltip className="color-premium" icon="icon-crown" size={IconSize.SIZE_ICON_20} tooltipText={window.i18next.t('pmwjs_automatically_spellcheck')} />;
  };

  return (
    <li className="flex-justify-between flex-items-center spacing-m-b-4 spacing-p-b-0">
      <div className="flexbox flex-items-center">
        <Text className={'spacing-m-r-2'} size={TextSize.XSMALL} val={window.i18next.t('pmwjs_spellcheck')} />
        {getTag()}
      </div>
      <div onClick={onClickHandler}>
        <ToggleSwitch size={props.toggleSize} isChecked={isSpellCheckEnabled} isLoading={isSpellCheckPreferenceUpdating} onChange={onClickHandler} />
      </div>
    </li>
  );
}
